import { type FormEvent, useState } from 'react';
import { LanguageSwitcher } from '@/components/language-switcher';
import { Button } from '@/components/ui/button';
import { Field, Input } from '@/components/ui/form';
import { ApiError } from '@/lib/api';
import { useAuth } from '@/lib/auth';
import { t } from '@/lib/i18n';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await login({ email, password, remember });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : t('Could not sign in'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-full items-center justify-center bg-gradient-to-br from-brand-900 via-brand-800 to-urban px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-4 rounded-xl border-t-4 border-accent bg-white p-8 shadow-2xl"
      >
        <div className="mb-4 text-center">
          <img src="/brand/logo.png" alt="Trafiku Urban Prishtine" className="mx-auto h-16 w-auto" />
          <h1 className="mt-4 text-base font-semibold text-brand-900">{t('Admin panel')}</h1>
          <p className="text-sm text-slate-500">{t('Sign in to manage the network')}</p>
        </div>
        <Field label={t('E-mail')}>
          {(id) => (
            <Input
              id={id}
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          )}
        </Field>
        <Field label={t('Password')}>
          {(id) => (
            <Input
              id={id}
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          )}
        </Field>
        <label className="flex items-center gap-2 text-sm text-slate-600">
          <input
            type="checkbox"
            checked={remember}
            onChange={(e) => setRemember(e.target.checked)}
            className="rounded border-slate-300"
          />
          {t('Keep me signed in for {n} days', { n: 30 })}
        </label>
        {error && <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>}
        <Button type="submit" loading={busy} className="w-full justify-center">
          {t('Sign in')}
        </Button>
        <div className="flex justify-center border-t border-slate-100 pt-4">
          <LanguageSwitcher />
        </div>
      </form>
    </div>
  );
}
